export default __webpack_public_path__ + "static/media/ic_face_id.87dd3e67.svg";